import {Component, effect, inject, OnDestroy} from '@angular/core';
import {ClinicianDashboardRoutes} from '@shared/common/routing/clinician-dashboard-routes';
import {ConsultationPopupRibbonService} from '@services/core/consultation-popup/consultation-popup-ribbon.service';
import {IRouteStructure} from '@shared/common/routing/IRouteStructure';
import {AppAuthService} from "@services/core/auth/app-auth.service";
import {AsyncPipe} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import {SidebarComponent} from '@shared/modules/layout-components/sidebar/sidebar.component';
import {HeaderComponent} from '@shared/modules/layout-components/header/header.component';
import {
  AppointmentRibbonComponent
} from "@app/areas/appointments/components/appointment-ribbon/appointment-ribbon.component";
import {CFTranslatorUtil} from "@shared/utils/code-feature-translation/CFTranslator.util";
import {IconMap} from "@shared/common/icons";
import { EnquiriesService } from '../areas/crm/enquiries/services/enquiries.service'

@Component({
  selector: 'app-clinician-dashboard-index',
  templateUrl: './clinician-dashboard-index.component.html',
  styleUrls: ['./clinician-dashboard-index.component.scss'],
  standalone: true,
  imports: [HeaderComponent, SidebarComponent, RouterOutlet, AsyncPipe, AppointmentRibbonComponent]
})
export class ClinicianDashboardIndexComponent implements OnDestroy {
  sidebarItems: IRouteStructure[] = [
    {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}`,
      localeKey: 'Sidebar.Home',
      translationDefault: 'Home',
      icon: IconMap.home,
    },
    {
      type: 'url',
      localPath: '',
      fullUrl: `/${ClinicianDashboardRoutes.DASHBOARD_PREFIX}/${CFTranslatorUtil.Prescriptions.snakeCase}`,
      localeKey: CFTranslatorUtil.Builder.default,
      translationDefault: 'Prescription Builder',
      icon: IconMap.builder,
    }
  ];

  private enquiries = inject(EnquiriesService)

  constructor(
    public consultationPopup: ConsultationPopupRibbonService,
    private authService: AppAuthService
  ) {
    if (this.authService.hasRole('admin')) {
      this.sidebarItems.push(ClinicianDashboardRoutes.FORMS.view)
      this.sidebarItems.push(ClinicianDashboardRoutes.INT_MONITORING.view)

      this.sidebarItems.push({
        type: 'url',
        localPath: '',
        fullUrl: `/cn/onboarding-cfg`,
        localeKey: 'Onboarding',
        translationDefault: 'Onboarding',
        icon: 'mdi-account-box-outline'
      })

      this.sidebarItems.push({
        type: 'url',
        localPath: '',
        fullUrl: `/cn/prescriptions/admin`,
        localeKey: 'Prescriptions',
        translationDefault: 'Prescriptions',
        icon: 'mdi-pill'
      })
    }

    if (this.authService.hasRole('user-admin')) {
      this.sidebarItems.push(ClinicianDashboardRoutes.USER_ADMIN.list)
    }

    if (this.authService.hasRole('knowledge-center-admin')) {
      this.sidebarItems.push({
        type: 'url',
        localPath: '',
        fullUrl: `/cn/articles`,
        localeKey: 'Library',
        translationDefault: 'Library',
        icon: 'mdi-book-open-page-variant-outline'
      })
    }

    if (this.authService.hasRole('applications-reviewer')) {
      this.sidebarItems.push({
        type: 'url',
        localPath: '',
        fullUrl: `/cn/applications`,
        localeKey: 'Applications',
        translationDefault: 'Applications',
        icon: 'mdi-stethoscope'
      })
    }

    effect(() => {
      if (this.authService.hasRole('customer-support')) {
        const u = '/cn/support'
        const index = this.sidebarItems.findIndex(e => e.fullUrl === u)
        const badgeCount = this.enquiries.badgeCount();
        const customerSupport = {
          type: 'url',
          localPath: '',
          fullUrl: `/cn/support`,
          localeKey: 'Support',
          translationDefault: 'Support',
          icon: 'mdi-information-outline',
          badgeCount
        } as IRouteStructure

        if (index !== -1) {
          this.sidebarItems[index] = customerSupport
        } else {
          this.sidebarItems.push(customerSupport)
        }
      }
    });

    if (this.authService.hasRole('translator')) {
      this.sidebarItems.push({
        type: 'url',
        localPath: '',
        fullUrl: `/cn/translation`,
        localeKey: 'Translation',
        translationDefault: 'Translation',
        icon: 'mdi-translate'
      })
    }
  }

  ngOnDestroy(): void {
  }
}
